import { Link } from 'react-router-dom'
import { penguinPadProjectPath, penguinPadProjectUrl } from '@/lib/shareSlug'

export default function SafePostText({
  text,
  extraLink,
  className = 'mt-2',
}: {
  text?: string
  extraLink?: string
  className?: string
}) {
  const caption = text?.trim() || ''
  const projectPath = extraLink ? penguinPadProjectPath(extraLink) : null
  const projectHref = extraLink ? penguinPadProjectUrl(extraLink) : null
  if (!caption && !projectPath)
    return null

  return (
    <div className={className}>
      {caption
        ? (
            <p
              className="pointer-events-none select-text whitespace-pre-wrap break-words [overflow-wrap:anywhere] text-sm leading-relaxed text-zinc-300 [&_a]:pointer-events-none [&_a]:cursor-text [&_a]:no-underline [&_a]:text-inherit"
              onClick={(event) => {
                event.preventDefault()
                event.stopPropagation()
              }}
              onAuxClick={(event) => {
                event.preventDefault()
                event.stopPropagation()
              }}
            >
              {caption}
            </p>
          )
        : null}
      {projectPath && projectHref
        ? (
            <Link
              to={projectPath}
              className={`${caption ? 'mt-1.5' : ''} inline-block max-w-full break-all text-sm font-medium text-lime-400 underline decoration-lime-400/50 underline-offset-2 hover:text-lime-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-lime-400/60`}
            >
              {projectHref}
            </Link>
          )
        : null}
    </div>
  )
}
